import React, { useEffect } from 'react';
import Type from 'prop-types';
import { Field, Form, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SimpleAutocomplete, CurrencyField, EmailField } from 'components';
import { useTranslation } from 'hooks';
import { useContracts, useDebtorInfo, useManagerInfo } from 'hooks/api/cascade';
import { useContacts } from 'hooks/api/contact';
import { fullDateFormat } from 'constants/dateFormats';
import { CascadeReportAction } from 'constants/actions';
import ActionField from '../ActionField';

const ClaimForm = (props) => {
  const { entityId } = props;
  const { t } = useTranslation();
  const { isSuccess: isDebtorSuccess, data: debtorInfo } =
    useDebtorInfo(entityId);
  const customerId = isDebtorSuccess ? debtorInfo?.debitor?.id : null;
  const {
    isLoading: isContactsLoading,
    isSuccess: isContactsSuccess,
    data: contacts,
  } = useContacts(customerId);
  const filteredContacts = isContactsSuccess
    ? contacts.filter((contact) => !!contact.email)
    : [];
  const { isLoading: isContractsLoading, data: contracts } =
    useContracts(entityId);
  const { isSuccess: isManagerInfoSuccess, data: managerInfo } =
    useManagerInfo(entityId);
  const { values, setFieldValue } = useFormikContext();
  const { action } = values;

  useEffect(() => {
    if (isManagerInfoSuccess) {
      setFieldValue('managerName', managerInfo.managerName);
      setFieldValue('managerPosition', managerInfo.managerPosition);
    }
  }, [isManagerInfoSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleContractChange = (event, newValue) => {
    setFieldValue('contract', newValue);
    setFieldValue('openDebt', newValue ? newValue.openDebt : '');
  };

  return (
    <Form noValidate>
      <Field
        id="contract"
        name="contract"
        component={SimpleAutocomplete}
        getOptionLabel={(option) => option.contract}
        options={contracts}
        onChange={handleContractChange}
        fullWidth
        loading={isContractsLoading}
        TextFieldProps={{
          label: t('contract'),
          required: true,
        }}
      />

      <Field
        name="openDebt"
        label={t('openDebt')}
        component={CurrencyField}
        margin="normal"
        options={{
          currency: 'RUB',
        }}
        fullWidth
        disabled
      />

      <Field
        name="claimNumber"
        component={TextField}
        label={t('claimNumber')}
        margin="normal"
        fullWidth
        required
      />

      <Field
        name="claimDate"
        label={t('claimDate')}
        component={DatePicker}
        format={fullDateFormat}
        margin="normal"
        cancelLabel={t('cancel')}
        disablePast
        fullWidth
        required
      />

      <ActionField name="action" required />

      <Field
        name="managerPosition"
        label={t('managerPosition')}
        component={TextField}
        margin="normal"
        fullWidth
        required
      />

      <Field
        name="managerName"
        label={t('managerName')}
        component={TextField}
        margin="normal"
        fullWidth
        required
      />

      <EmailField
        name="email"
        loading={isContactsLoading}
        disabled={action !== CascadeReportAction.SEND_EMAIL}
        options={filteredContacts}
        fullWidth
        TextFieldProps={{
          label: t('email'),
        }}
      />
    </Form>
  );
};

ClaimForm.propTypes = {
  entityId: Type.string.isRequired,
};

export default ClaimForm;
